export const cataloguePagePath = '/catalogue';